import { usePath } from './router';
import { ReportsPage } from './pages/ReportsPage';
import { ReportDetailPage } from './pages/ReportDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { UploadPage } from './pages/UploadPage';

export function App() {
  const path = usePath();
  const reportMatch = path.match(/^\/report\/([^/]+)$/);
  if (reportMatch) {
    return <ReportDetailPage reportId={decodeURIComponent(reportMatch[1])} />;
  }
  if (path === '/settings') {
    return <SettingsPage />;
  }
  if (path === '/upload') {
    return <UploadPage />;
  }
  return <ReportsPage />;
}
